"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SevenAnniversaryRequest = void 0;
var SevenAnniversaryRequest = /** @class */ (function () {
    function SevenAnniversaryRequest() {
    }
    return SevenAnniversaryRequest;
}());
exports.SevenAnniversaryRequest = SevenAnniversaryRequest;
;
//# sourceMappingURL=sevenAnniversary.request.js.map